uvex-newsletter-modal {
  display: block;

  .modal-content {
    max-width: 900px;
    background: #fff;
    padding: 0;
    overflow-x: visible;
  }

  .media {
    margin-bottom: 0;
  }

  .media-left {
    padding-right: 0;
    margin-bottom: 0;
  }

  .media-body {
    padding: 2rem;
  }

  .modal-close {
    .layout-default & {
      color: #000;
    }
  }

  .modal-backdrop:not(.in) {
    visibility: hidden;
  }

  @media (max-width: 600px) {
    .media-left {
      display: none;
    }
  }
}
